import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import {
    MasterAdminIcon,
    MonitorPerfIcon,
    PaymentGateIcon,
    FeatureRollIcon,
    CustomerAnalyIcon,
    AccessSetIcon,
} from "../../../../app-constants"

const Robustsolution = () => {
    return (
        <div className="robust_solution p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Integrated, Robust & One-Window Backend To Control The App’s Features</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {MasterAdminIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Master Admin Panel</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Control everything on your on-demand app through this dashboard including payments, commissions, user profiles, reviews, comments and payments.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {MonitorPerfIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Monitor Performance</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Attain access to all the important performance metrics on your on-demand app and manage performance based issues through the right analytics.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {PaymentGateIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Payment Gateway</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Keep track of all your payments and earnings through your on-demand app with the added ability to restrict access to this feature to non-concerned personnel.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {FeatureRollIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Feature Rollout</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>App management panel is synchronized with the music app’s user interface to ensure that no security issues or glitches linger around for long.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {CustomerAnalyIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Customer Analytics</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Access to user analytics is a special part of our backend support as it allows you to optimize user experience based on real time usage data gathered from all parts of the music app.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {AccessSetIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Access Settings</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Redact, add or modify any settings within the app with stunning ease and incredible accuracy from a single, highly optimized platform.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Robustsolution